import React from "react";
import { useNavigate } from "react-router-dom";
import "./Exercise1Failed.css"; // Make sure to create this CSS file

const Exercise1Failed = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate("/exercise1intro");
  };

  return (
    <div className="exercise1-failed-container">
      <div className="failed-content">
        <h1>Let's give it another go. Tap below whenever you're ready!</h1>
        <p>
          This time, make sure to breathe properly and stay focused.  
          Take your time and try again!
        </p>
        <button className="retry-button" onClick={handleRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default Exercise1Failed;
